import { Map } from 'immutable'
import { IFeaturedImageHash } from 'hooks/useImages'

const frItems: IFeaturedImageHash = {
  common: {
    'not-found': {
      alt: '404: Page introuvable',
      url: '/assets/images/shared/404.jfif'
    }
  },
  header: {
    logo: {
      alt: 'logo Iliad',
      url: '/assets/images/shared/logo_groupe.png',
      link: '/fr'
    }
  },
  navigation: {
    'photo-library': {
      alt: 'Photothèque',
      url: '/assets/images/shared/photo-library.jpg',
      text: ['Photothèque']
    }
  }
}

const enItems: IFeaturedImageHash = {
  common: {
    'not-found': {
      alt: '404: Page not found',
      url: '/assets/images/shared/404.jfif'
    }
  },
  header: {
    logo: {
      alt: 'Iliad logo',
      url: '/assets/images/shared/logo_groupe_en.png',
      link: '/en'
    }
  },
  navigation: {
    'photo-library': {
      alt: 'Photo library',
      url: '/assets/images/shared/photo-library.jpg',
      text: ['Photo library']
    }
  }
}

let localizedImages = Map<string, IFeaturedImageHash>()
localizedImages = localizedImages.set('fr', frItems)
localizedImages = localizedImages.set('en', enItems)

export const featureImages = localizedImages
